// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3Oq1O","infoBtn":"quickbooks_infoBtn__1Oe4M","formBox":"quickbooks_formBox__3PoDT","formFooter":"quickbooks_formFooter__2fynE"};